setTimeout(function(){
 (function(window) {

  'use strict';

  var mainContainer = document.querySelector('.main-wrap'),
   openCtrl = document.getElementById('searchBtn'),
   closeCtrl = document.getElementById('searchCloseBtn'),
   searchContainer = document.querySelector('.search'),
   inputSearch = searchContainer.querySelector('.search-input');

  let searchContainerIsOpen = false;

  function init() {
   initEvents();
  }

  function initEvents() {
    openCtrl.addEventListener('click', function () {
      trackGA4(this, 'topnav_search');
      openSearch();
    });
    
    openCtrl.addEventListener('click', openSearch);


   closeCtrl.addEventListener('click', closeSearch);
   document.addEventListener('keyup', function(ev) {
    // escape key.
    if( ev.keyCode == 27 ) {
     closeSearch();
    }
   });

   openCtrl.addEventListener('keyup', function(ev) {
      // if ENTER
      if ( ev.keyCode == 13) {
        openSearch();
      }
    });

    closeCtrl.addEventListener('keyup', function(ev) {
      // if ENTER
      if ( ev.keyCode == 13) {
        closeSearch();
      }
    });
  }

  function hidebody() {
      $('header').attr('aria-hidden', 'true');
      $('section').attr('aria-hidden', 'true');
      $('footer').attr('aria-hidden', 'true');
      $('header').attr('tabindex', '-1');
      $('section').attr('tabindex', '-1');
      $('footer').attr('tabindex', '-1');
  }

  function showbody() {
      $('header').attr('aria-hidden', 'false');
      $('section').attr('aria-hidden', 'false');
      $('footer').attr('aria-hidden', 'false');
      $('header').attr('tabindex', '0');
      $('section').attr('tabindex', '0');
      $('footer').attr('tabindex', '0');
  }

  function openSearch() {
    mainContainer.classList.add('main-wrap-move');
    searchContainer.classList.add('search-open');
    $('#sitesearchform').attr('aria-hidden', 'false');
    hidebody();
    $('.searchfocushide').attr('tabindex', '0');
    setTimeout(function() {
      // inputSearch.focus();
      closeCtrl.focus();
    }, 600);

    searchContainerIsOpen = true;
  }

  function closeSearch() {
    mainContainer.classList.remove('main-wrap-move');
    searchContainer.classList.remove('search-open');
    $('#sitesearchform').attr('aria-hidden', 'true');
    showbody();
    $('.searchfocushide').attr('tabindex', '-1');
    inputSearch.blur();
    inputSearch.value = '';
    openCtrl.focus();

    searchContainerIsOpen = false;
  }

  // Focus Trap
  const focusableElements = searchContainer.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"]');
  const firstFocusableEl = focusableElements[0];
  const lastFocusableEl = focusableElements[focusableElements.length - 1];

  document.addEventListener('keydown', e => {
    if (e.key === "Tab" || e.keyCode === 9) {
      if (!searchContainerIsOpen) return;

      if (!searchContainer.contains(e.target)) {
        closeCtrl.focus();
        e.preventDefault();
      }

      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    }
  });

  init();

 })(window);
}, 300);
